import { ReferenceType } from '@modules/client/types/globalTypes';
import { TTranslateFunction } from '@modules/localization/types/TranslateFunction';
import {
  labelTranslKeyByReferenceType,
  referenceTypeByTitle,
} from '@modules/apiReference/page/constants/apiReferenceConstants';

export const LABEL_ENGINE_API_KEY = 'Label.EngineAPI';
export const REFERENCE_ENGINE_CLASSES_NODE_PATH = '/reference/engine/classes';

export const getTranslatedNodeIdForReferenceType = (
  referenceType: ReferenceType,
  translate: TTranslateFunction,
): string => {
  const labelTranslKeyForType = labelTranslKeyByReferenceType[referenceType];
  const translatedEngineApi = translate(LABEL_ENGINE_API_KEY);
  const translatedLabel = translate(labelTranslKeyForType);
  return `${translatedEngineApi}/${translatedLabel}`;
};

export const getTranslatedReferenceNodeId = (
  nodeId: string,
  translate: TTranslateFunction,
): string => {
  const [nameForPartI, nameForPartII, ...rest] = nodeId.split('/');
  if (rest.length !== 0) return nodeId;
  if (nameForPartI !== translate(LABEL_ENGINE_API_KEY)) return nodeId;
  const referenceType = referenceTypeByTitle[nameForPartII];
  return getTranslatedNodeIdForReferenceType(referenceType, translate);
};
